export default __webpack_public_path__ + "static/media/appStoreWhite.bf74a6ae.svg";